// settingKey — ключ продукту в налаштуваннях лендингу (settings.products), як у uconnect-client
export default {
    computed: {
        landingProducts() {
            return [
                { key: 'tourism', settingKey: 'tourism', name: 'Туризм', path: '/insurance/tourism', disabled: false },
                { key: 'oscpv', settingKey: 'oscpv', name: 'ОСЦПВ', path: '/insurance/oscpv', disabled: false },
                { key: 'green_card', settingKey: 'greencard', name: 'Зелена Картка', path: '/insurance/greencard', disabled: false },
                { key: 'kasko', name: 'КАСКО', path: '/insurance/kasko', disabled: true },
                { key: 'miniKasko', name: 'Міні Каско', path: '/insurance/mini-kasko', disabled: true },
                { key: 'home', name: 'Страхування житла', path: '/insurance/home', disabled: true },
            ];
        }
    }
}
